import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Picker from 'react-month-picker'
import MonthBox from "views/MonthBox.jsx";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import $ from "jquery";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class UserAccessPermission extends Component{
    constructor(props) {
        super(props);
        this.state = {
            userType: '',
            userSubGroupLists:[],
            userSubGroup:'',
            userSubGroupValue:'',
            userGroup:'',
            userGroups:[],
            accessName:'',
            accessType:'',
            _notificationSystem: null,
            loading:false,
            isSubmit:false,
            accessData:[]
        };

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.get_all_permission();
    }
    get_all_permission(){
        var that = this;

        var postData = {
            userGroup: this.state.userGroup,
            userSubGroup: this.state.userSubGroup,
            accessType:this.state.accessType,
            accessName: this.state.accessName
        };
        if ($.fn.DataTable.isDataTable('#userAccessTable')) {
            $('#userAccessTable').DataTable().clear().destroy();
        }
        var userAccessTable = $('#userAccessTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
//                 "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/users/user-permission-lists",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {

                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {

                    },
                    complete: function (data) {

                    },
                },

                columns: [
                    {"data":"group_name", "width":"100px"},
                    {"data":"subgroup_name", "width":"100px"},
                    {"data":"access_type"},
                    {"data":"access_name"},
                    {"data":"pid"},
                ],
                "columnDefs": [
                    {
                        "width": "15%",
                        render: function (data, type, row) {

                            return '<td ><a href="#" data-tip="Delete" data-id="' + data + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
                                '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
                                '</a>' +

                                '</td>';
                        },
                        className: "action_button",
                        targets: 4,
                        aTargets: [-1]
                    },

                ]
            });
            $('#userAccessTable').on('click', 'td.action_button a', function (e) {
            e.stopImmediatePropagation();
            var id = $(this).data("id");
                that.delete_permission(id)
            });
    }
    delete_permission(id){
        var data = {
            permission_id:id
        }
        axios.post(config.get('API_URL') + '/users/delete_user_access_permission/', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => { console.log("kkk", response.data)
            if(response.data.status==='Deleted!') {
                this.handleNotificationClick("tr", 1, "Record has been deleted successfully");
                this.get_all_permission();
            }
        });
    }
    changeUserType(e) {
        this.setState({
            userType : e.target.value,
            userSubGroupLists :[],
            userSubGroup:'',
            userSubGroupValue:[],
        })
        if(e.target.value!=""){
            this.findGroups(e.target.value, 'add');
        } else {
            this.setState({
                userGroups:[],
                userGroup:''
            })
        }
    }

    findGroups(val, change_type) {
        axios.get(config.get('API_URL') + '/users/usergroups/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                userType: val,
                object_type: 'Innoviti'
            }


        }).then(response => {
            this.setState({
                userGroups: response.data,
            })

        });

    }

    changeUserGroups(e){
        this.setState({
            userGroup : e.target.value,
        })
        if(e.target.value!=""){
            this.findSubGroups(e.target.value,'');
        } else {
            this.setState({
                userSubGroupLists :[],
                userSubGroup:'',
                userSubGroupValue:[],
            })
        }

    }
    findSubGroups(val, load_type) {

        axios.get(config.get('API_URL') + '/users/getsubgroup/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                groupId: val
            }

        }).then(response => {
            var mList = []
            if (Array.isArray(response.data) && response.data.length) {

                response.data.map((subgroup, index) => {
                    mList.push({value: subgroup.subgroup_id, label: subgroup.subgroup_name})
                });
                this.setState({
                    userSubGroupLists: mList
                })
            }


        });
    }

    changeUserSubGroups(optionSelected){
        let value='';
        let subgroupArray = [];
        let accessData=[];
        if(optionSelected.length<1){
            value = null;
            subgroupArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                subgroupArray.push(mids.value)

                var index = this.state.userSubGroupLists.findIndex(obj => obj.value == mids.value);
                this.state.userSubGroupLists.move(index, 0).join(',');

            });
        }

        this.setState({
            userSubGroupValue:optionSelected,
            userSubGroup:subgroupArray,
            accessData:accessData
        });

    }

    changeAccessType(e){
        this.setState({
            accessType : e.target.value,
        })
    }
    onChangeInput(e){
        this.setState({
            accessName : e.target.value,
        })
    }
    addPermission(e){
        if(this.state.userType==''){
            this.handleNotificationClick("tr", 3, "Please Select User Type");
            return false;
        }
        if(this.state.userGroup==''){
            this.handleNotificationClick("tr", 3, "Please Select User Group");
            return false;
        }
        if(this.state.userSubGroup==''){
            this.handleNotificationClick("tr", 3, "Please Select User Sub Group");
            return false;
        }
        if(this.state.accessType==''){
            this.handleNotificationClick("tr", 3, "Please Select Access Type");
            return false;
        }
        if(this.state.accessName==''){
            this.handleNotificationClick("tr", 3, "Please Select Access Name");
            return false;
        }
        var accessData =[];
        this.state.userSubGroup.map((mids, i) => {
            //console.log(mids);
            accessData.push({
                group_id: this.state.userGroup,
                subgroup_id: mids,
                access_type: this.state.accessType,
                access_name: this.state.accessName
            });
        });
        var data = {
            permission_data:accessData
        }
        //console.log(data);
        //return false;
        axios.post(config.get('API_URL') + '/users/add_user_access_permission/', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
               //console.log("ffffffffff", response);
               if(response.data.status==='ok'){
                    this.setState({
                        userType: '',
                        userSubGroup:'',
                        userSubGroupValue:[],
                        userGroup:'',
                        accessName:'',
                        accessType:'',
                        accessData:[]
                    })
               }
               this.handleNotificationClick("tr", 1, "Record has been added successfully");
               this.get_all_permission();
        });
    }
    searchPermission(e){
        if(this.state.userType==''){
            this.handleNotificationClick("tr", 3, "Please Select User Type");
            return false;
        }
        if(this.state.userGroup==''){
            this.handleNotificationClick("tr", 3, "Please Select User Group");
            return false;
        }
        this.get_all_permission();
    }
    render() { //console.log(this.state.accessType); console.log(this.state.accessName);
        let allgroups = this.state.userGroups.map((group, index) => {
            return (
                <option value={group.group_id} key={index + 1}>{group.group_name}</option>
            )
        });
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">User Access Permission</h4>
                                    {/*<p className="category"></p>*/}

                                </div>
                                <hr className="m-0"/>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-2  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">User Type</label>
                                                <select name="userType" className="form-control"
                                                            value={this.state.userType}
                                                            onChange={this.changeUserType.bind(this)}
                                                    disabled={this.state.disableInput}>
                                                        <option value="">Select</option>
                                                        <option value="Internal">Internal</option>
                                                        <option value="External">External</option>

                                                    </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">User Group</label>
                                                <select id="adduserGroup" name="userGroup" className="form-control"
                                                        value={this.state.userGroup}
                                                        onChange={this.changeUserGroups.bind(this)}
                                                        >
                                                        <option value="">Select</option>
                                                    {allgroups}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">User Subgroup</label>
                                                <ReactMultiSelectCheckboxes name="sub_group"
                                                    isMulti
                                                    value={this.state.userSubGroupValue}
                                                    styles={reactSelectStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeUserSubGroups.bind(this)}
                                                    options={this.state.userSubGroupLists}
                                                    placeholderButtonLabel="Select [Subgroup]"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Access Type</label>
                                                <select name="accessType" className="form-control"
                                                            value={this.state.accessType}
                                                            onChange={this.changeAccessType.bind(this)}
                                                   >
                                                        <option value="">Select</option>
                                                        <option value="Menu">Menu</option>
                                                        <option value="Submenu">Submenu</option>
                                                        <option value="Tab">Tab</option>
                                                        <option value="report">Report</option>
                                                        <option value="BrandEMI">BrandEMI</option>
                                                        <option value="Function">Function</option>

                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-2  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Access Name</label>
                                                <input className="form-control" id="accessName" name="accessName" value={this.state.accessName}
                                                       onChange={this.onChangeInput.bind(this)} />
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="row">
                                            <div className="col-md-4 pull-right">
                                                <button width="100%" type="button" className="btn btn-primary" onClick={this.addPermission.bind(this)}>Add Permission</button>
                                                &nbsp; &nbsp;<button width="100%" type="button" className="btn btn-primary" onClick={this.searchPermission.bind(this)}>Search</button>
                                                <div className='sweet-loading'>
                                                    <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={20}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/*<div className="col-md-3 pull-left">*/}
                                        {/*    */}
                                        {/*</div>*/}
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="row">
                                    <div className="clearfix"></div>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                            <table id="userAccessTable" className="table table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th width="100px">Group Name</th>
                                                        <th>Subgroup Name</th>
                                                        <th>Access Type</th>
                                                        <th>Access Name</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default UserAccessPermission